import React from "react";
import { FilterItems } from "./FilterItems";
import { FilterHeader } from "./FilterHeader";
import { Collapsible } from "lib/Collapsible";
import { isInUrl } from "lib/routing";

export const FilterAccordian = (props) => (
  <Collapsible
    header={(toggleOpen, isOpen) => <FilterHeader toggleOpen={toggleOpen} isOpen={isOpen} {...props} />}
    isVisible={isFilterVisible(props)}
  >
    <FilterItems {...props} />
  </Collapsible>
);

export const isFilterVisible = (props) => {
  if (props.category_en !== "Industry Groups") return true;
  const isSectorOrIGroupsActive = isInUrl(["Sectors=", "Sectors-JA=", "Industry%20Groups=", "Industry%20Groups-JA="]);
  return isSectorOrIGroupsActive;
};
